module.exports = __webpack_public_path__ + "static/media/default_ticket.35b59a2e.jpg";